<template>
  <div class="test-edit">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/test-list' }">问卷管理</el-breadcrumb-item>
      <el-breadcrumb-item>编辑</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="body">
      <p class="title">
        <el-input
          placeholder="请输入问卷标题"
          v-model="title"
          clearable>
        </el-input>
      </p>
      <p class="title">
        <el-input
          placeholder="请输入问卷指导语"
          v-model="instruction"
          clearable>
        </el-input>
      </p>
      <p>
        <el-select v-model="test_variety_id" placeholder="请选择问卷分类">
          <el-option
            v-for="item in variety_list" size="small"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </p>
      <div class="dimension">
        <div class="left">
          <el-button plain @click="addDimension"> + 添加维度</el-button>
        </div>
        <ul>
          <li v-for="dimension in dimension_list">
            {{dimension}}
            <i class="el-icon-circle-close" @click="deleteDimension(dimension)"></i>
          </li>
        </ul>
      </div>
      <p>
        <el-button type="primary" @click="addQuestion"> + 添加问题</el-button>
      </p>
      <div class="list">
        <div class="item" v-for="(q,index) in question" :key="q.vue_id">
          <p class="question">
            <span>{{index + 1}}.</span>
            <el-input
              type="textarea"
              autosize
              v-model="q.content"
              placeholder="请输入内容">
            </el-input>
            <el-button type="danger" szie="small" @click="deleteQuestion(q.vue_id)">删除</el-button>
          </p>
          <p class="option_add">
            <el-select v-model="q.dimension" placeholder="请选择问题维度" size="small" v-if="dimension_list.length">
              <el-option
                v-for="item in dimension_list"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
            <el-button type="primary" plain @click="addOption(q.vue_id)">+ 添加选项</el-button>
          </p>
          <ul class="option">
            <li v-for="option_item in q.option" :key="option_item.vue_id">
              <span>选项：</span>
              <p class="p_1">
                <el-input
                  placeholder="请输入内容"
                  v-model="option_item.content"
                  size="small"
                  clearable>
                </el-input>
              </p>
              <span>分数：</span>
              <el-input-number size="mini" v-model="option_item.score"></el-input-number>
              <i class="el-icon-delete" @click="deleteOption(q.vue_id, option_item.vue_id)"></i>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="body-1">
      <p>
        <el-button type="primary" @click="addBoundary"> + 添加评分标准</el-button>
      </p>
      <ul class="boundary">
        <li v-for="boundary in standards_grading" :key="boundary.vue_id">
          <span>分数：</span>
          <el-input-number size="mini" v-model="boundary.min_score"></el-input-number>
          <span class="divide">至</span>
          <el-input-number size="mini" v-model="boundary.max_score"></el-input-number>
          <p class="p_1">
            <el-input
              placeholder="请输入内容"
              v-model="boundary.content"
              size="small"
              clearable>
            </el-input>
          </p>
          <i class="el-icon-delete" @click="deleteBoundary(boundary.vue_id)"></i>
        </li>
      </ul>
    </div>
    <div class="body-1">
      <p class="p_dan">
        <span>反馈内容：</span>
        <el-input
          placeholder="请输入内容"
          type="textarea"
          v-model="feedback_content"
          size="small"
          clearable>
        </el-input>
      </p>
    </div>
    <p align="center">
      <el-button type="primary" @click="submitTest">提交</el-button>
    </p>

    <el-dialog
      title="填写维度"
      :visible.sync="centerDialogVisible"
      width="400px"
      center>
      <el-input
        placeholder="请输入内容"
        v-model="dimension_name">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click.native="submitDimension()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>


<script>
  import { nanoid } from 'nanoid'

  export default {
    data() {
      return {
        id:'',
        centerDialogVisible:false,
        dimension_name:'',
        title:'',
        instruction:'',
        variety_list:[],
        test_variety_id:'',
        dimension_list:[],
        question: [
          {
            content:'',
            dimension:'',
            option:[
              {content:'', score:0, vue_id:nanoid()}
            ],
            vue_id:nanoid()
          }
        ],
        standards_grading:[
          {content:'',min_score:0,max_score:0, vue_id:nanoid()}
        ],
        feedback_content:''
      }
    },
    methods: {
      getVariety(){
        this.$get('/v1/admin/label?&pages=1&limit=1000&type=questionnaire', {})
          .then((res) => {
            if (res.data.status === 'success') {
              this.variety_list = res.data.data.data;
            } else {
              this.$msg(res.data.msg)
            }
          });
      },
      getInfo(){
        this.$get('/v1/admin/questionnaire-info?&id=' + this.$route.query.id, {})
          .then((res) => {
            console.log(res)
            if (res.data.status === 'success') {
              this.id = res.data.data.data.id;
              this.title = res.data.data.data.title;
              this.instruction = res.data.data.data.instruction;
              this.test_variety_id = res.data.data.data.label_id;
              this.dimension_list = res.data.data.data.dimension_list || [];
              this.question = res.data.data.data.question;
              this.standards_grading = res.data.data.data.standards_grading;
              this.feedback_content = res.data.data.data.feedback_content;
            } else {
              this.$msg(res.data.msg)
            }
          });
      },
      addDimension(){
        this.centerDialogVisible = true
      },
      submitDimension(){
        if(this.dimension_name){
          this.dimension_list.push(this.dimension_name);
          this.dimension_name ='';
          this.centerDialogVisible = false
        }
      },
      deleteDimension(dimension){
        let id1 = this.dimension_list.findIndex(item => {
          if (item === dimension) {
            return true
          }
        });
        this.dimension_list.splice(id1, 1)
      },
      addQuestion(){
        let  temp = {
          content:'',
          dimension:'',
          option:[
            {content:'',score:0,vue_id:nanoid()}
          ],
          vue_id:nanoid()
        };
        this.question.push(temp);
      },
      deleteQuestion(vue_id) {
        let id1 = this.question.findIndex(q => {
          if (q.vue_id === vue_id) {
            return true
          }
        });
        this.question.splice(id1, 1)
      },
      addOption(vue_id){
        let  temp = {content:'',score:0, vue_id:nanoid()};
        this.question.forEach((item)=>{
          if(item.vue_id ===vue_id){
            item.option.push(temp)
          }
        })
      },
      deleteOption(q_id,option_id){
        this.question.forEach((item)=>{
          if(item.vue_id === q_id){
            let id1 = item.option.findIndex(option_item => {
              if (option_item.vue_id === option_id) {
                return true
              }
            });
            item.option.splice(id1, 1)
          }
        })
      },
      addBoundary(){
        let  temp = {item:'',min_score:0,max_score:0, vue_id:nanoid()};
        this.standards_grading.push(temp);
      },
      deleteBoundary(vue_id){
        let id1 = this.standards_grading.findIndex(item => {
          if (item.vue_id === vue_id) {
            return true
          }
        });
        this.standards_grading.splice(id1, 1)
      },
      submitTest(){
        if(!this.title){
          this.$msg('请填写问卷标题！');
          return false;
        }

        if(!this.instruction){
          this.$msg('请填写问卷指导语！');
          return false;
        }

        //校验问题
        for(let i = 0 ; i < this.question.length ; i++){
          let index = i+1;
          if(!this.question[i].content){
            this.$msg('请完善第'+ index +'题问题！');
            return false;
          }

          for(let j = 0 ; j < this.question[i].option.length ; j++){
            if(!this.question[i].option[j].content){
              this.$msg('请完善第'+ index +'题选项！');
              return false;
            }
          }
        }
        //校验评分标准
        for(let i = 0 ; i < this.standards_grading.length ; i++){
          let index = i+1;
          if(!this.standards_grading[i].content){
            this.$msg('请完善第'+ index +'条评分标准！');
            return false;
          }

          if(this.standards_grading[i].min_score >= this.standards_grading[i].max_score){
            this.$msg('第'+ index +'条评分标准请填写合理分数区间！');
            return false;
          }
        }

        if(!this.feedback_content){
          this.$msg('请填写反馈内容！');
          return false;
        }


        let data = {
          id: this.id,
          title: this.title,
          instruction: this.instruction,
          label_id:this.test_variety_id,
          dimension_list: this.dimension_list,
          standards_grading: this.standards_grading,
          question: this.question,
          feedback_content: this.feedback_content
        };

        this.$put('/v1/admin/questionnaire', data)
          .then((res) => {
            console.log(res)
            if (res.data.status === 'success') {
              this.$router.go(-1);
            } else {
              this.$msg(res.data.msg)
            }
          });
      },
      goTo(path,id){
        this.$router.push({
          path:path,
          query:{
            id:id
          }
        })
      }
    },
    created() {
      this.getVariety();
      this.getInfo();
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  .test-edit
    .body
      min-height 250px
      padding 16px 20px
      margin-top 20px
      border 1px solid #EBEEF5
      .title
        font-size 18px
        line-height 36px
        margin-bottom 12px
      .dimension
        width 100%
        padding 10px 10px 10px 0
        margin 10px 0 20px
        display flex
        background #eee
        border-radius 8px
        ul
          margin 0 20px
          display flex
          flex-wrap wrap
          li
            position relative
            height 30px
            padding 0 10px
            margin-top 4px
            margin-right 16px
            font-size 12px
            line-height 30px
            color #fff
            background #66afe9
            border-radius  4px
            &:hover .el-icon-circle-close
              display block
            .el-icon-circle-close
              display none
              position absolute
              top -7px
              right -7px
              color red
              font-size 16px
              font-weight 600
              background #eee
              border-radius 50%
      .list
        .item
          margin 20px 0 30px
          .question
            display  flex
            span
              line-height 30px
            button
              height 32px
              margin-left 20px
              padding 0 20px
          .option_add
            margin-top 10px
            .el-select
              margin-left 10px
            button
              height 32px
              margin-left 12px
              padding 0 20px
          .option
            li
              display flex
              justify-content flex-start
              align-items center
              padding-left 12px
              margin-top:10px
              .p_1
                width 300px
                margin-right:20px
                input
                  height 30px
              .el-icon-delete
                width 20px
                height 20px
                margin-left 20px
                &:before
                  font-size 20px
                &:hover
                  color red
    .body-1
      min-height 50px
      padding 16px 20px
      margin 20px 0
      border 1px solid #EBEEF5
      .title
        font-size 18px
        line-height 36px
      .boundary
        li
          display flex
          justify-content flex-start
          align-items center
          padding-left 12px
          margin-top:10px
          .p_1
            width 500px
            margin:0 12px
            input
              height 30px
          .divide
            margin 0 10px
          .el-icon-delete
            width 20px
            height 20px
            margin-left 20px
            &:before
              font-size 20px
            &:hover
              color red

</style>



// WEBPACK FOOTER //
// src/pages/TestAdd/TestEdit.vue